import React from "react";
import HeroSection from "./HeroSection";
import GoToContent from "./GoToContent";

const HeroSectionFreePeriod = () => {
  return (
    <HeroSection
      title="PMIstandards+  Success at Your Fingertips"
      tagLine="Try this new digital solution for instant access to the PMI standards, guides, how-to content and more—all tailored to industry, approach and goals."
      tagLineTwo=""
    >
      <GoToContent />
    </HeroSection>
  );
};

export default HeroSectionFreePeriod;
